export default __webpack_public_path__ + "static/media/protoio.18645082.svg";